/* ENGORI — Kennzeichnung KI-gestützter Bilder und Videos
   ---------------------------------------------------------------------------
   Hängt an jedes Bild und jedes Video ein rundes "i" unten rechts. Der Hinweis
   erscheint beim Überfahren mit der Maus und beim Antippen — ohne Tap-Variante
   würden ihn Handynutzer nie zu sehen bekommen.

   Warum per Skript und nicht im Template: Die Medien stecken in Dutzenden
   verschiedener Container (Banner, Galerie, Produktbilder, Kundenfotos,
   Slider). Ein Wrapper je Template wäre an jeder Stelle anders und würde bei
   jedem Theme-Update wieder auseinanderlaufen.
*/
(function () {
  'use strict';

  var TEXT_BILD = 'Dieses Bild entstand durch KI-Unterstützung.';
  var TEXT_VIDEO = 'Dieses Video entstand durch KI-Unterstützung.';
  var MIN_KANTE = 96;      // Icons, Zahlungslogos und Sterne bleiben frei
  var MARKIERT = 'data-eng-ki';
  var BEOBACHTET = 'data-eng-ki-warte'; // Bild wartet auf seine Maße

  // Bilder, die keine Fotos sind
  var AUSGENOMMEN = [
    '.header__heading-logo',      // Shop-Logo
    // Bildblöcke im Footer: Logo und Gütesiegel. Das sind gestaltete Marken-
    // grafiken in derselben Rolle wie das Shop-Logo darüber, keine Produkt-
    // aufnahmen — hier trägt das Zeichen nichts bei und säße zudem in der
    // leeren Ecke des quadratischen Bildkastens, weit weg vom runden Siegel.
    '.footer-block__image-wrapper',
    // Newsletter-Fenster: Das Produktbild darin ist nur Beiwerk zum Rabatt.
    // Dasselbe Foto trägt den Hinweis bereits auf der Produktseite.
    '.eng-np__media',
    // Hero-Banner: statt eines Zeichens je Bild traegt die Section einen
    // einzigen Sammelhinweis (Einstellung ki_hinweis in engori-hero-taschen).
    '.eht',
    // Hover-Buehne der Karten: das Einzelbild darunter traegt das Zeichen bereits.
    '.eng-kb__buehne',
    /* Farbkacheln der Variantenauswahl. Sie werden mit 50 Pixeln dargestellt,
       lägen also unter MIN_KANTE — aber bei lazy geladenen Bildern ist die
       gemessene Breite im ersten Moment 0, und dann greift der Rückfall auf
       naturalWidth. Der liegt bei 150 und damit über der Schwelle, weshalb
       jede Kachel ein Zeichen bekam. Hier grundsätzlich ausgenommen: Das
       Produktfoto daneben trägt den Hinweis ohnehin. */
    '.color-swatch',
    '.color-swatch__image',
    '.payment-badge img',
    '.eng-bnf__icon img',
    '.trustpilot__stars img',
    '.engori-trust-belt-icon img',
    // Vorschaubilder der Produktgalerie: Dasselbe Foto trägt den Hinweis schon
    // im großen Bild daneben. Auf den kleinen Kacheln wäre er nur Unruhe.
    '.thumbnail',
    '.thumbnail-list__item',
    '.thumbnail-slider',
    'svg'
  ].join(',');

  function istVideo(el) {
    return el.tagName === 'VIDEO';
  }

  /* Der Anker fürs Zeichen. In der Produktgalerie ist das `.media` — bei Videos
     liegt dazwischen noch ein <internal-video>, dessen Kasten nicht der ganzen
     Bühne entspricht. `closest` überspringt diese Zwischenschicht; überall
     sonst bleibt es beim direkten Elternelement wie bisher. */
  function traegerVon(el) {
    return el.closest('.media') || el.parentElement;
  }

  /* 25.09.2026: Messen und Schreiben getrennt (CODE-04, PERF-06). Vorher las
     jedes Bild Maße und Stil und schrieb sofort Stil und Knopf ins DOM; die
     nächste Messung erzwang dann jedes Mal ein neues Layout. Jetzt vermisst
     vermessen() alle Kandidaten, anhaengen() schreibt danach in einem Zug.
     Liefert einen Plan mit den gemessenen Werten oder null. `belegt` sammelt
     die Träger dieses Durchgangs, weil deren Zeichen erst im zweiten Schritt
     entstehen und `:scope > .eng-ki` sie noch nicht sieht. */
  function vermessen(el, sammel, belegt) {
    // Billige Prüfungen zuerst, Layout-Abfragen erst danach.
    if (el.hasAttribute(MARKIERT)) return null;
    var traeger = traegerVon(el);
    if (!traeger) return null;

    if (sammel) {
      // Sammelanker: ohne Groessenpruefung, ein Zeichen je Traeger.
      var t = el.parentElement;
      if (!t || t.querySelector(':scope > .eng-ki') || belegt.indexOf(t) !== -1) return null;
    } else {
      if (el.closest(AUSGENOMMEN)) return null;
      // Poster-Bild und Video teilen sich denselben Kasten — sonst zwei Zeichen.
      if (traeger.querySelector(':scope > .eng-ki') || belegt.indexOf(traeger) !== -1) return null;

      /* Massgeblich ist, wie gross das Bild DARGESTELLT wird — nicht, wie gross
         die Datei ist. Bei lazy geladenen Bildern liefert getBoundingClientRect
         im ersten Moment 0; der Rueckfall auf naturalWidth misst dann die
         Quelldatei und haengt auch an winzigen Kacheln ein Zeichen an. Deshalb
         zuerst die width/height-Attribute, die die gedachte Anzeigegroesse
         angeben, und erst zuletzt die Dateimasse. */
      var r = el.getBoundingClientRect();
      var attrB = parseInt(el.getAttribute('width'), 10) || 0;
      var attrH = parseInt(el.getAttribute('height'), 10) || 0;
      var breite = r.width || attrB || el.naturalWidth || el.videoWidth || 0;
      var hoehe = r.height || attrH || el.naturalHeight || el.videoHeight || 0;
      if (breite < MIN_KANTE || hoehe < MIN_KANTE) return null;
    }

    var stil = window.getComputedStyle(traeger);
    belegt.push(traeger);
    if (sammel) belegt.push(el.parentElement);
    return {
      el: el,
      traeger: traeger,
      // Das Zeichen braucht einen positionierten Anker, sonst rutscht es weg.
      statisch: stil.position === 'static',
      /* Ein nacktes <a> um ein Bild ist ein Inline-Element: Seine Box hat keine
         verlässliche Höhe, das absolut positionierte Zeichen landet dann im
         Nichts. Genau so lag das Premium-Siegel im Footer — angehängt, aber
         unsichtbar. inline-block gibt dem Anker die Maße des Bildes, ohne den
         Textfluss zu ändern. */
      inline: stil.display === 'inline',
      /* Abstand zur Ecke an die Rundung anpassen. Bei einem Radius R liegt der
         Bogen auf der Diagonalen um rund 0,29·R von der Ecke entfernt — ein
         festes Maß säße bei stark gerundeten Kacheln (Radius 20 bis 40) mitten
         in der Rundung und bei kantigen Bildern unnötig weit innen. Geprüft
         werden Träger und Bild, weil mal der eine, mal das andere gerundet ist. */
      radius: Math.max(
        parseFloat(stil.borderBottomRightRadius) || 0,
        parseFloat(window.getComputedStyle(el).borderBottomRightRadius) || 0
      )
    };
  }

  // Zweiter Schritt: nur noch schreiben, keine Layout-Abfragen.
  function anhaengen(plan) {
    var img = plan.el;
    var traeger = plan.traeger;
    img.setAttribute(MARKIERT, '1');
    /* Sammelhinweis (13.09.2026): Ein unsichtbarer Anker mit
       data-eng-ki-sammel steht fuer mehrere Bilder zugleich, z. B. im
       Hero-Banner. Er bekommt dasselbe Zeichen, der Text kommt aus
       data-eng-ki-text. */
    var TEXT = img.getAttribute('data-eng-ki-text') ||
               (istVideo(img) ? TEXT_VIDEO : TEXT_BILD);

    if (plan.statisch) traeger.style.position = 'relative';
    if (plan.inline) traeger.style.display = 'inline-block';
    var abstand = Math.round(Math.max(6, plan.radius * 0.30 + 4));

    var b = document.createElement('button');
    b.type = 'button';
    // Videos haben in der Galerie stärker gerundete Ecken als Bilder — das
    // Zeichen braucht dort mehr Abstand, sonst sitzt es in der Rundung.
    b.className = istVideo(img) ? 'eng-ki eng-ki--video' : 'eng-ki';
    b.style.setProperty('right', abstand + 'px', 'important');
    b.style.setProperty('bottom', abstand + 'px', 'important');
    b.setAttribute('aria-label', TEXT);
    b.innerHTML = '<span class="eng-ki__i" aria-hidden="true">i</span>' +
                  '<span class="eng-ki__text" role="tooltip">' + TEXT + '</span>';

    // Antippen zeigt den Hinweis, ohne einen darunterliegenden Link auszulösen.
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var offen = b.classList.contains('is-offen');
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
      if (!offen) b.classList.add('is-offen');
    });

    /* 13.09.2026: Die Sprechblase darf hoechstens 60 % der Bildbreite
       einnehmen (Wunsch Werner: sie verdeckte das Produkt grossflaechig). Sie
       haengt am 18-px-Zeichen, eine Prozentangabe in CSS bezoege sich also
       auf 18 px statt aufs Bild. Deshalb misst das Skript die tatsaechliche
       Bildbreite und gibt sie als Variable weiter — bei jedem Oeffnen, weil
       sich die Bildgroesse mit dem Fenster aendert.
       Der Hinweis selbst bleibt unveraendert erhalten (Art. 50 KI-VO).
       25.09.2026: nicht mehr zusätzlich beim Anhängen gemessen (erzwang je
       Zeichen ein Layout); bis zum ersten Öffnen gilt die CSS-Obergrenze. */
    function setzeMax() {
      var w = traeger.getBoundingClientRect().width;
      /* / 1.08: Das geoeffnete Zeichen ist per CSS mit scale(1.08)
         vergroessert, die Sprechblase waechst mit. Ohne den Ausgleich lag sie
         sichtbar bei 61 statt 60 % der Bildbreite (gemessen 13.09.2026). */
      if (w > 0) b.style.setProperty('--eng-ki-max', Math.floor(w * 0.6 / 1.08) + 'px');
    }
    b.addEventListener('mouseenter', setzeMax);
    b.addEventListener('focus', setzeMax);
    b.addEventListener('click', setzeMax, true);

    /* 25.09.2026 (BFSG-07): Escape schließt die per Fokus offene Blase über
       .is-zu (CSS-Seite in engori-premium.css). Verlässt Fokus oder Maus das
       Zeichen, gilt wieder der Normalzustand. */
    b.addEventListener('blur', function () { b.classList.remove('is-zu'); });
    b.addEventListener('mouseleave', function () { b.classList.remove('is-zu'); });

    /* 25.09.2026 (BFSG-06, BFSG-02): Keine Tabstopp-Flut. In aria-hidden-
       Kopien (Slider-Klone) weder fokussierbar noch vorgelesen; in Links und
       ab dem zweiten Zeichen einer Section nur per Maus/Touch erreichbar.
       Sichtbar bleiben alle Zeichen. */
    if (traeger.closest('[aria-hidden="true"]')) {
      b.tabIndex = -1;
      b.setAttribute('aria-hidden', 'true');
    } else if (traeger.closest('a[href]')) {
      b.tabIndex = -1;
    } else {
      var sek = traeger.closest('.shopify-section');
      if (sek && sek.querySelector('.eng-ki:not([tabindex="-1"])')) b.tabIndex = -1;
    }

    traeger.appendChild(b);
  }

  /* Beide Schritte für eine Liste: erst alle vermessen, dann alle anhängen.
     Reihenfolge der Liste zählt (Videos vor Bildern, Sammelanker zuletzt). */
  function bearbeiten(normale, sammelAnker) {
    var belegt = [];
    var plaene = [];
    normale.forEach(function (el) {
      var p = vermessen(el, false, belegt);
      if (p) plaene.push(p);
    });
    (sammelAnker || []).forEach(function (el) {
      var p = vermessen(el, true, belegt);
      if (p) plaene.push(p);
    });
    plaene.forEach(anhaengen);
  }

  /* Bilder mit loading="lazy" haben beim ersten Durchlauf weder Maße noch
     Bilddaten und fallen deshalb durch die Größenprüfung. Da Lazy-Loading das
     DOM nicht verändert, greift auch der MutationObserver nicht — das Siegel
     im Footer blieb so bisher ohne Kennzeichnung. Zwei Netze dagegen: ein
     load-Ereignis je Bild und ein IntersectionObserver für Bilder, die schon
     geladen, beim Durchlauf aber noch außerhalb des Sichtfelds waren. */
  var sichtbarkeit = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        var neu = [];
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          sichtbarkeit.unobserve(e.target);
          neu.push(e.target);
        });
        if (neu.length) bearbeiten(neu);
      }, { rootMargin: '200px' })
    : null;

  function nachzuegler() {
    document.querySelectorAll('img:not([' + MARKIERT + ']):not([' + BEOBACHTET + '])')
      .forEach(function (img) {
        img.setAttribute(BEOBACHTET, '1');
        img.addEventListener('load', function () {
          bearbeiten([img]);
        }, { once: true });
        if (sichtbarkeit) sichtbarkeit.observe(img);
      });
  }

  function liste(selektor) {
    return Array.prototype.slice.call(document.querySelectorAll(selektor));
  }

  function durchlauf() {
    // Bewusst Videos vor Bildern: `querySelectorAll('video, img')` liefert in
    // Dokumentreihenfolge, nicht in Selektorreihenfolge. Liegt in einem Kasten
    // beides (Video plus Posterbild), soll das Zeichen am Video hängen und
    // "Dieses Video …" sagen — deshalb müssen Videos zuerst drankommen.
    var frei = ':not([' + MARKIERT + '])';
    bearbeiten(
      liste('video' + frei).concat(liste('img' + frei)),
      liste('[data-eng-ki-sammel]' + frei)
    );
    nachzuegler();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.eng-ki')) {
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
      // 25.09.2026 (BFSG-07): auch die per Fokus geöffnete Blase schließen.
      var a = document.activeElement;
      if (a && a.classList && a.classList.contains('eng-ki')) a.classList.add('is-zu');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchlauf);
  } else {
    durchlauf();
  }

  /* Nachgeladene Bilder (Slider, Varianten-Wechsel, Warenkorb) mitnehmen.
     25.09.2026 (CODE-04, PERF-06): nur noch, wenn wirklich ein Bild, Video
     oder Sammelanker dazukommt. Vorher lief der Durchlauf bei jeder DOM-
     Änderung, auf /cart durch den Countdown jede Sekunde, und die eigenen
     Zeichen lösten ihn erneut aus. */
  var SUCHE = 'img, video, [data-eng-ki-sammel]';
  function bringtMedien(n) {
    if (n.nodeType !== 1 || n.classList.contains('eng-ki')) return false;
    return n.matches(SUCHE) || !!n.querySelector(SUCHE);
  }
  var warte;
  new MutationObserver(function (aenderungen) {
    for (var i = 0; i < aenderungen.length; i++) {
      var neu = aenderungen[i].addedNodes;
      for (var j = 0; j < neu.length; j++) {
        if (bringtMedien(neu[j])) {
          clearTimeout(warte);
          warte = setTimeout(durchlauf, 250);
          return;
        }
      }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Bilder ohne feste Maße sind beim ersten Durchlauf noch 0 breit.
  window.addEventListener('load', durchlauf);
})();
